import { getQueryObject } from './utils/extend';

const storageParams = () => {
  try {
    const params: any = getQueryObject(window.location.href) || {};
    localStorage.setItem('token', params.token);
    localStorage.setItem('position', params.gravity || 'bottom');
    localStorage.setItem('standard', params.standard || '0');
  } catch(err) {
    console.log(err)
  }
}

const initDsbridge = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  if (isIOS) {
    // window.awsdk = {}
    // console.log('x', Object.keys(SdkTypes))
  }
}

const init = () => {
  storageParams()
  initDsbridge()
}

init();